import React from 'react';
import Helmet from 'react-helmet'
import Layout from '../components/Layout'
import Background from '../components/Background'
import PrismicDOM from 'prismic-dom'
import {RichText} from 'prismic-reactjs';
import Grid from 'styled-components-grid';
import {Padding} from 'styled-components-spacing'
import {GridContainer, IntroGridUnit} from '../components/Styles'
import ImageLink from '../components/ImageLink'


const IndexPage = (props) => {
  const { data } = props;
  const content = data.content.data;
  return (
    <Layout 
      navigationLinks={data.menu.data.body}
      meteoLinks={data.meteo.data}
      pagesUrl={data.allPagesUrl}
      bannerImage={content.header_image}
      bannerImages={content.header_images}
    >
     <Helmet
      title={content.meta_title}
      meta={[
        { name: 'description', content: content.meta_description }
      ]}
      />
      <Background backgroundImage={content.background}>
        <Padding bottom={4}>
          <Grid halign="center">
            <IntroGridUnit>
              {RichText.render(content.introduction)}
            </IntroGridUnit>
          </Grid>
          <GridContainer>
            <Grid horizontalAlign="justfy">
              {content.body.map(({primary}) => (
                <ImageLink
                  key={primary.name}
                  image={primary.image.url}
                  alt={primary.image.alt}
                  to={primary.link_to_content.slug}
                  name={primary.name}
                />
              ))}
            </Grid>
          </GridContainer>
          <Grid halign="center">
            <IntroGridUnit>
              <p><small><em>Le parapente est un médicament aéropathique, consultez votre praticien, tenir hors de portée des enfants</em></small></p>
            </IntroGridUnit>
          </Grid>
        </Padding>
      </Background>
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query PageIndexContent {
    menu:  prismicDocument(type: {eq: "navigation"}) {
      ...NavigationLinks
    }
    meteo: prismicDocument (type: {eq: "menu_meteo"}){
      ...MenuMeteo
    }
    allPagesUrl: allSitePage {
      ...PagesUrl
    }
    content: prismicDocument(type: {eq: "index"}) {
      data {
        meta_description 
        meta_title
        header_images {
          slideshow_image {
            url
            alt
            xl { url }
            md { url }
            sm { url }
          }
        }
        introduction {
          text
          type
          spans {
            start
            end
            type
          }
        }
        background {
          url
          xl { url }
          md { url }
          sm { url }
        }
        body {
          primary {
            image {
              url
              xl { url }
              md { url }
              sm { url }
            }
            link_to_content {
              slug
            }
            name
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/index.js